import { Link } from "react-router-dom";
import { Star, ArrowRight } from "lucide-react";
import { IMG, waLink } from "@/lib/brand";

const items = [
  { q: "My daughter went from 68% to 92% in one year at Vikramshila. The teachers' attention to each child is unmatched.", by: "Mrs. Sunita Kumari", role: "Parent · Class X student", avatar: IMG.studentFemale, type: "Parent" },
  { q: "The weekly test system keeps my son disciplined. Best decision we made for his studies.", by: "Mr. Rakesh Sharma", role: "Parent · Class IX student", avatar: IMG.studentMale, type: "Parent" },
  { q: "Concept clarity, honest fees, and constant communication with parents. Highly recommended.", by: "Mrs. Anita Verma", role: "Parent · Class VIII student", avatar: IMG.studentFemale, type: "Parent" },
  { q: "I used to hate Maths. Now it's my favourite subject — thanks to my Vikramshila teachers.", by: "Aarav K.", role: "Class X CBSE", avatar: IMG.studentMale, type: "Student" },
  { q: "The doubt sessions are the best part. No question is ever considered silly here.", by: "Priya S.", role: "Class IX ICSE", avatar: IMG.studentFemale, type: "Student" },
  { q: "Small batch means my teacher knows exactly where I struggle. I improved so fast.", by: "Rohan V.", role: "Class X CBSE", avatar: IMG.studentMale, type: "Student" },
  { q: "I appreciated the monthly progress reports — very transparent teaching.", by: "Mr. Deepak Ranjan", role: "Parent · Class X student", avatar: IMG.studentMale, type: "Parent" },
  { q: "Vikramshila made board prep less stressful for our entire family.", by: "Mrs. Kavita Roy", role: "Parent · Class X student", avatar: IMG.studentFemale, type: "Parent" },
  { q: "I love how the teachers explain Science with real-life examples.", by: "Aditya R.", role: "Class VIII", avatar: IMG.studentMale, type: "Student" },
];

export default function TestimonialsPage() {
  return (
    <div>
      <section className="bg-[#0B192C] text-white relative overflow-hidden">
        <div className="vk-grain" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <span className="vk-chip">Reviews</span>
          <h1 className="mt-4 font-display text-5xl sm:text-6xl font-800 tracking-tight max-w-3xl">What parents &amp; students say about us.</h1>
          <p className="mt-5 max-w-2xl text-lg text-white/70">Nothing speaks louder than the words of our families. Here&apos;s what they have to say about their journey with Vikramshila Classes.</p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((t,i)=>(
            <article key={i} data-testid={`testimonial-${i}`} className="rounded-lg border border-slate-200 bg-[#F5F7FA] p-7 flex flex-col">
              <div className="flex items-center justify-between">
                <div className="flex gap-1">{[...Array(5)].map((_,j)=>(<Star key={j} size={14} className="text-[#FF6B35] fill-[#FF6B35]" />))}</div>
                <span className="vk-chip text-xs">{t.type}</span>
              </div>
              <p className="mt-4 text-slate-800 leading-relaxed flex-1">&ldquo;{t.q}&rdquo;</p>
              <div className="mt-6 flex items-center gap-3">
                <img src={t.avatar} alt={`${t.by} avatar`} className="w-11 h-11 rounded-full object-cover border border-slate-200" loading="lazy" />
                <div>
                  <div className="text-sm font-semibold text-[#0B192C]">{t.by}</div>
                  <div className="text-xs text-slate-500">{t.role}</div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="py-16 bg-[#0B192C] text-white relative overflow-hidden">
        <div className="vk-grain" />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-display text-4xl font-800">Join the Vikramshila Classes family</h2>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <Link to="/contact" className="vk-btn-primary">Book Free Demo <ArrowRight size={16} /></Link>
            <a href={waLink()} target="_blank" rel="noreferrer" className="vk-btn-outline">WhatsApp Now</a>
          </div>
        </div>
      </section>
    </div>
  );
}
